import {MODAL_OPEN, MODAL_CLOSE} from '../constants/Modal'

const initialState = {
  opened: false
}

export default function modal(state = initialState, action) {
  switch (action.type) {
    case MODAL_OPEN:
      return {
        ...state,
        opened: true
      };
    case MODAL_CLOSE:
      return {
        ...state,
        opened: false
      };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/modal.js